import { AppData } from "../../../types";
import { ShowModalDialogPayload } from "../../../actions";

export type ShowModalDialogOptions = {
  appData: AppData;
  payload: ShowModalDialogPayload;
};

export function showModalDialog({
  appData,
  payload,
}: ShowModalDialogOptions): AppData {
  return { ...appData, modalDialog: payload };
}
